import { useState } from "react";
import { MoveHorizontal } from "lucide-react";
import { SampleBadge, RealBadge } from "./SampleBadge";

export const BeforeAfter = ({ before, after, beforeAlt, afterAlt, testId, real = false, className = "aspect-[4/3]" }) => {
  const [pos, setPos] = useState(50);
  return (
    <div className={`relative overflow-hidden rounded-2xl bg-slate-200 select-none ${className}`} data-testid={testId}>
      <img src={after} alt={afterAlt} loading="lazy" className="absolute inset-0 h-full w-full object-cover" />
      <img src={before} alt={beforeAlt} loading="lazy" className="absolute inset-0 h-full w-full object-cover"
        style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }} />
      <div className="pointer-events-none absolute inset-y-0 w-0.5 bg-white shadow-[0_0_0_1px_rgba(15,30,54,0.15)]" style={{ left: `${pos}%` }}>
        <span className="absolute top-1/2 left-1/2 grid h-11 w-11 -translate-x-1/2 -translate-y-1/2 place-items-center rounded-full bg-white text-[var(--navy)] shadow-xl">
          <MoveHorizontal className="h-5 w-5" />
        </span>
      </div>
      <span className="pointer-events-none absolute top-4 left-4 rounded-full bg-[var(--navy)]/85 px-3 py-1 text-xs font-bold tracking-widest text-white">BEFORE</span>
      <span className="pointer-events-none absolute top-4 right-4 rounded-full bg-[var(--green)] px-3 py-1 text-xs font-bold tracking-widest text-white">AFTER</span>
      {real ? <RealBadge /> : <SampleBadge />}
      <input type="range" min="0" max="100" value={pos} onChange={(e) => setPos(Number(e.target.value))}
        aria-label="Drag to compare before and after" data-testid={`${testId}-range`}
        className="ba-range absolute inset-0 h-full w-full cursor-ew-resize opacity-0" />
    </div>
  );
};
